const types = {
  UPDATE_FIELD: 'UPDATE_FIELD',
  SET_SAVED_ON_SERVER: 'SET_SAVED_ON_SERVER',
};

export default types;
